import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { ReactComponent as EyeOn } from '../assets/eye_on.svg';
import { ReactComponent as EyeOff } from '../assets/eye_off.svg';
import './PasswordField.css';

function PasswordField({
  onChange = null,
  value = '',
  autoComplete = "current-password",
  placeholder = "Password",
  wrapperClassName="",
  className = '',
  id = 'password',
  labelText = "Password",
  ...props
}) {
  const [ passwordVisible, setPasswordVisible ] = useState(false);

  return(
    <>
      <Form.Label className="form-label visually-hidden" htmlFor="password">{labelText}</Form.Label>
      <div className={`input-group ${wrapperClassName}`}>
        <Form.Control
          className={className}
          id={id}
          placeholder={placeholder}
          type={passwordVisible ? "text" : "password"}
          autoComplete="current-password"
          value={value}
          onChange={onChange}
          props
        />
        <span className={`input-group-text eye-wrapper ${className}`}>
          {
            passwordVisible ? (
              <EyeOff
                className="eye"
                alt="Hide password."
                title="Hide password."
                onClick={() => setPasswordVisible(false)}
              />
            ) : (
              <EyeOn
                className="eye"
                alt="Show password."
                title="Show password."
                onClick={() => setPasswordVisible(true)}
              />
            )
          }
          
        </span>
      </div>
    </>
  );
}

PasswordField.propTypes = {
  /**
   * Onchange function for the form control.
   */
  onChange: PropTypes.func,
  /**
   * Value for the form control.
   */
  value: PropTypes.string,
  /**
   * Autocomplete property for the form control.
   */
  autoComplete: PropTypes.string,
  /**
   * Placeholder property for the form control.
   */
  placeholder: PropTypes.string,
  /**
   * Classname for the form control.
   */
  className: PropTypes.string,
  /**
   * Classname for the outer wrapper.
   */
  wrapperClassName: PropTypes.string,
  /**
   * Text for the label.
   */
  labelText: PropTypes.string,
  /**
   * Id for the form control.
   */
  id: PropTypes.string,
 }

export default PasswordField;